(function(){
  // 你的 JSON 文件 URL（确保指向上一步创建的 JSON）
  var JSON_URL = "https://raw.githubusercontent.com/OtisFMCN/shopify-theme-base/main/content/home-collage.json";

  // 本地缓存（分钟）
  var TTL_MINUTES = 60;
  function now() { return Math.floor(Date.now()/1000); }

  function getCache(key) {
    try {
      var str = localStorage.getItem(key);
      if (!str) return null;
      var obj = JSON.parse(str);
      if (obj.expireAt && obj.expireAt > now()) return obj.value;
      return null;
    } catch(e){ return null; }
  }

  function setCache(key, value, ttlMinutes) {
    try {
      localStorage.setItem(key, JSON.stringify({
        value: value,
        expireAt: now() + (ttlMinutes*60)
      }));
    } catch(e){}
  }

  function applyCollage(cfg){
  if (!cfg || !cfg.items) return;

  var items = [
    cfg.items.collage1 || null,
    cfg.items.collage2 || null,
    cfg.items.collage3 || null
  ];

  // 1) 先尝试你之前如果已经加过的固定 id（向后兼容）
  var idImgs = [
    document.getElementById('collage1-img'),
    document.getElementById('collage2-img'),
    document.getElementById('collage3-img')
  ];
  var idLinks = [
    document.getElementById('collage1-link'),
    document.getElementById('collage2-link'),
    document.getElementById('collage3-link')
  ];
  var hasAllIds = idImgs.every(Boolean);
  if (hasAllIds){
    items.forEach(function(item, idx){
      if (!item) return;
      var img = idImgs[idx], a = idLinks[idx] || null;
      if (img && item.image){ img.src = item.image; if (item.alt) img.alt = item.alt; img.loading = 'lazy'; img.decoding='async'; }
      if (a && item.link){ a.href = item.link; }
    });
    return;
  }

  // 2) Dawn Collage 自动定位（不改 liquid）
  // 选择器：collage section 里的图片（只取前三张）
  var container = document.querySelector('.collage') || document.querySelector('.collage-wrapper') || document;
  if (!container) return;

  // Dawn 的图片都在 .collage__item--image 里，用 image_tag 输出成 <img>
  var imgs = container.querySelectorAll('.collage__item--image img, .collage img, img');
  if (!imgs || imgs.length < 1) return;

  // 取前三张作为 collage1/2/3
  for (var i = 0; i < 3; i++){
    var conf = items[i];
    var imgEl = imgs[i];
    if (!conf || !imgEl) continue;

    // 替换图片和 alt
    if (conf.image) {
      imgEl.src = conf.image;
      imgEl.removeAttribute('srcset'); // 避免旧的 srcset 抢占
      imgEl.removeAttribute('sizes');
      imgEl.loading = 'lazy';
      imgEl.decoding = 'async';
    }
    if (conf.alt) {
      imgEl.alt = conf.alt;
    }

    // 处理链接：如果本来就有 <a> 父级就设 href；没有就加点击跳转
    var aParent = imgEl.closest('a');
    if (conf.link) {
      if (aParent) {
        aParent.href = conf.link;
      } else {
        imgEl.style.cursor = 'pointer';
        imgEl.addEventListener('click', function(url){
          return function(){ window.location.href = url; };
        }(conf.link));
      }
    }
  }
}

      

  function fetchAndApply(){
    var cacheKey = "mcn_collage_json";
    var cached = getCache(cacheKey);
    if (cached) {
      applyCollage(cached);
      return;
    }
    fetch(JSON_URL, { cache: "no-store" })
      .then(function(res){ return res.json(); })
      .then(function(json){
        applyCollage(json);
        setCache(cacheKey, json, TTL_MINUTES);
      })
      .catch(function(err){
        console.warn("Collage dynamic load failed:", err);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fetchAndApply);
  } else {
    fetchAndApply();
  }
})();
